(function (global) {
  var PAGE_SIZE = 6;
  var CATEGORY_KEYS = [
    'Absorption of Vitamins/Minerals', 'AIDS / HIV', "Alzheimer's",
    'Animals & Livestock', 'Antifungal', 'Anti-Inflammatory', 'Antioxidant',
    'Antiviral', 'Arthritis', 'Asthma / Bronchitis', 'Cancer',
    'Candida Albicans', 'Chronic Fatigue | Energy', 'COVID-19',
    'Detox | Natural removal of heavy metals', 'Diabetes',
    'Early discovery of Fulvic & Humic',
    'Graphene Oxide Removal / Detoxification', 'Gut Health', 'Immune System',
    'Liver function improvement', 'Lyme like symptoms', 'Research Articles',
    'Skin', 'Sports Performance', 'Thyroid', 'Trace Elements',
    'Tuberculosis', 'Videos',
  ];

  function categoryForControl(control) {
    var categoryIndexAttribute = control.getAttribute('data-cat-index');
    var categoryIndex = categoryIndexAttribute === null ? NaN : Number(categoryIndexAttribute);
    return Number.isInteger(categoryIndex) && CATEGORY_KEYS[categoryIndex]
      ? CATEGORY_KEYS[categoryIndex]
      : control.getAttribute('data-cat') || '__all__';
  }

  function filterItems(items, query, category) {
    var normalizedQuery = String(query || '').trim().toLowerCase();
    return items.filter(function (item) {
      var categories = Array.isArray(item.categories) ? item.categories : [];
      var categoryMatch = category === '__all__' || categories.includes(category);
      var queryMatch = normalizedQuery === '' || String(item.text || '').toLowerCase().includes(normalizedQuery);
      return categoryMatch && queryMatch;
    });
  }

  function buildPaginationModel(total, requestedPage, pageSize) {
    var pageCount = Math.ceil(Math.max(0, total) / pageSize);
    var page = pageCount === 0 ? 1 : Math.min(Math.max(1, requestedPage), pageCount);
    var start = pageCount === 0 ? 0 : (page - 1) * pageSize;
    return { page: page, pageCount: pageCount, start: start, end: Math.min(start + pageSize, total) };
  }

  function reveal(root) {
    var reducedMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var elements = root.querySelectorAll('.bn-reveal');
    if (reducedMotion || !('IntersectionObserver' in global)) {
      elements.forEach(function (element) { element.classList.add('is-in'); });
      return;
    }

    var observer = new global.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    elements.forEach(function (element) { observer.observe(element); });
  }

  function init(root) {
    if (!root || root.__bnResearchLibraryInitialized) return;

    var list = root.querySelector('[data-rl-list]');
    var search = root.querySelector('[data-rl-search]');
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-rl-filter]'));
    var categoryLabels = Object.create(null);
    controls.forEach(function (control) {
      var category = categoryForControl(control);
      if (category !== '__all__' && !categoryLabels[category]) {
        categoryLabels[category] = String(control.textContent || category).trim();
      }
    });
    var empty = root.querySelector('[data-rl-empty]');
    var count = root.querySelector('[data-rl-count]');
    var status = root.querySelector('[data-rl-status]');
    var pagination = root.querySelector('[data-rl-pagination]');
    if (!list || !pagination) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('[data-rl-item]')).map(function (element) {
      return {
        element: element,
        categories: (element.getAttribute('data-cats') || '').split('||').filter(Boolean),
        primaryCategory: element.getAttribute('data-primary-cat') || '',
        text: element.getAttribute('data-text') || '',
      };
    });
    var activeCategory = '__all__';
    var activeCategoryLabel = '';
    var page = 1;

    function updateControls() {
      controls.forEach(function (control) {
        var active = categoryForControl(control) === activeCategory;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function createPageButton(label, targetPage, options) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bn-rl-page' + (options.active ? ' is-active' : '') + (options.direction ? ' bn-rl-page--next' : '');
      button.textContent = label;
      button.setAttribute('aria-label', options.ariaLabel);
      if (options.active) {
        button.setAttribute('aria-current', 'page');
        button.setAttribute('data-rl-page', String(targetPage));
      }
      button.disabled = options.disabled;
      button.addEventListener('click', function () {
        page = targetPage;
        render(page);
      });
      return button;
    }

    function renderPagination(model, focusPage) {
      pagination.replaceChildren();
      if (model.pageCount === 0) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;
      pagination.appendChild(createPageButton('‹', model.page - 1, {
        ariaLabel: window.BionoboI18n.s_5de35bfaa47ef868ba940042,
        disabled: model.page === 1,
        active: false,
        direction: true,
      }));
      for (var number = 1; number <= model.pageCount; number += 1) {
        pagination.appendChild(createPageButton(String(number), number, {
          ariaLabel: window.BionoboI18n.s_8a1d865bda2b9b3794b7f94d + number,
          disabled: false,
          active: number === model.page,
          direction: false,
        }));
      }
      pagination.appendChild(createPageButton('›', model.page + 1, {
        ariaLabel: window.BionoboI18n.s_23dc0ead5444e8b9192334dd,
        disabled: model.page === model.pageCount,
        active: false,
        direction: true,
      }));
      if (focusPage) {
        var currentPageButton = pagination.querySelector('[data-rl-page="' + model.page + '"]');
        if (currentPageButton) currentPageButton.focus();
      }
    }

    function render(focusPage) {
      var query = search ? search.value : '';
      var filtered = filterItems(items, query, activeCategory);
      var model = buildPaginationModel(filtered.length, page, PAGE_SIZE);
      page = model.page;
      var visibleItems = filtered.slice(model.start, model.end);

      renderPagination(model, focusPage);
      items.forEach(function (item) {
        item.element.hidden = visibleItems.indexOf(item) === -1;
        var area = item.element.querySelector('[data-rl-area]');
        if (area) {
          area.textContent = activeCategory === '__all__'
            ? categoryLabels[item.primaryCategory] || item.primaryCategory
            : activeCategoryLabel;
        }
      });
      if (count) count.textContent = filtered.length + (filtered.length === 1 ? window.BionoboI18n.s_908dec2e939efa3b984ee422 : window.BionoboI18n.s_8703f7249915049d83e7b573);
      if (status) {
        status.textContent = filtered.length + (filtered.length === 1 ? window.BionoboI18n.s_f230d71e34f9b38560a032e6 : window.BionoboI18n.s_a4abd123530081b8a9f8e49d)
          + (model.pageCount ? window.BionoboI18n.s_e42da9cafdb27c177d7a512a + model.page + window.BionoboI18n.s_ea60907bfe5320a821b6dfe6 + model.pageCount + '.' : window.BionoboI18n.s_802097f427fe336078a25fd4);
      }
      if (empty) empty.hidden = filtered.length !== 0;
    }

    function setActive(category, label) {
      activeCategory = category;
      activeCategoryLabel = category === '__all__' ? '' : String(label || category).trim();
      page = 1;
      updateControls();
      render();
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        var category = categoryForControl(control);
        var nextCategory = category === activeCategory ? '__all__' : category;
        setActive(nextCategory, control.textContent);
      });
    });
    if (search) {
      search.addEventListener('input', function () {
        page = 1;
        render();
      });
    }

    reveal(root);
    updateControls();
    render();
    root.__bnResearchLibraryInitialized = true;
  }

  function handleSectionLoad(event) {
    var target = event && event.target;
    var root = target && target.matches && target.matches('.bn-rl-library')
      ? target
      : target && target.querySelector
        ? target.querySelector('.bn-rl-library')
        : null;
    if (root) init(root);
  }

  var api = {
    init: init,
    handleSectionLoad: handleSectionLoad,
    filterItems: filterItems,
    buildPaginationModel: buildPaginationModel,
    categoryForControl: categoryForControl,
    categoryKeys: CATEGORY_KEYS.slice(),
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  global.BionoboResearchLibrary = api;

  if (typeof document !== 'undefined') {
    function initializeAll() {
      document.querySelectorAll('.bn-rl-library').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', handleSectionLoad);
  }
})(typeof window === 'undefined' ? globalThis : window);
